import {
  ApiClient,
  ApiClientContext,
  ApiClientOptions,
  RouteOptions,
  defaultAxiosConfig,
} from '@qualifio/api-client';
import { AxiosInstance, AxiosResponse } from 'axios';

export class RedirectApiClient extends ApiClient {
  static serviceName = 'redirect';
  static scopeName = 'redirect';

  constructor(http?: AxiosInstance, context?: ApiClientContext, options?: ApiClientOptions) {
    if (context === ApiClientContext.FRONTEND) {
      throw new Error('This api client is not made to be used in the frontend');
    }

    super('/', http, context, options);
  }

  async registerDomain(fqdn: string, options?: RouteOptions): Promise<boolean> {
    const params = new URLSearchParams();
    params.append('domainName', fqdn);

    const response = await this.http.post('/app/services/external-redirect.cfm', params, {
      ...defaultAxiosConfig(options),
      params: { ...options?.params, method: 'registerDomain' },
    });
    return isRequestSuccessful(response);
  }

  async unregisterDomain(fqdn: string, options?: RouteOptions): Promise<boolean> {
    const params = new URLSearchParams();
    params.append('domainName', fqdn);

    const response = await this.http.post('/app/services/external-redirect.cfm', params, {
      ...defaultAxiosConfig(options),
      params: { ...options?.params, method: 'deleteDomain' },
    });
    return isRequestSuccessful(response);
  }

  async createRedirection(
    fqdn: string,
    fromPath: string,
    toPath: string,
    options?: RouteOptions,
  ): Promise<{ redirectId: number }> {
    const params = new URLSearchParams();
    params.append('domainName', fqdn);
    params.append('target', fromPath);
    params.append('redirectTo', toPath);
    const { data } = await this.http.post('/app/services/external-redirect.cfm', params, {
      ...defaultAxiosConfig(options),
      params: { ...options?.params, method: 'createRedirection' },
    });
    return { redirectId: data };
  }

  async removeRedirection(redirectId: number, options?: RouteOptions): Promise<boolean> {
    const params = new URLSearchParams();
    params.append('redirectId', `${redirectId}`);

    const response = await this.http.post('/app/services/external-redirect.cfm', params, {
      ...defaultAxiosConfig(options),
      params: { ...options?.params, method: 'deleteRedirection' },
    });
    return isRequestSuccessful(response);
  }
}

function isRequestSuccessful(response: AxiosResponse<any>): boolean {
  const status = response.status;
  return !!status && status >= 200 && status < 300;
}
